import type { ListBuilderList } from '../../../types';

/**
 * Quote Inquiries list configuration
 * Shows sourcing requests of type 'quote'
 */
export const quoteInquiriesList: ListBuilderList = {
	id: 'default-sourcing-requests-quote-inquiries',
	cacheTTL: 300000,
	name: 'Quote Inquiries',
	type: 'default',
	active: true,
	sortOrder: 5,
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestType: {
			defaultValue: [{ id: 'quote', label: 'Quote' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
